import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sr-only" }

import {AuthStore} from "@/stores/auth";
    import { useI18n } from 'vue-i18n';
    import {reactive} from "vue";
    interface State {
       favorite:boolean
    }
    interface Props {
        code:string,
        type:string,
        favorite:boolean
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'FavoriteButton',
  props: {
    code: null,
    type: null,
    favorite: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
        code:string,
        type:string,
        favorite:boolean
    };

    const authStore = AuthStore();

    const { t, locale } = useI18n();
    
    const state = reactive<State>({
        favorite:props.favorite
    });
    
    const toggle = (e:Event)=>{
        e.preventDefault();
        if(props.type ==='article') {
            if(state.favorite) {
                authStore.removeFavoriteArticle(props.code);
            } else {
                authStore.addFavoriteArticle(props.code);
            }
        } else if(props.type ==='shop') {
            if(state.favorite) {
                authStore.removeFavoriteShop(props.code);
            } else {
                authStore.addFavoriteShop(props.code);
            }
        }
        
        state.favorite = !state.favorite;       
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["btn-favorite", {'selected' :state.favorite}]),
    type: "button",
    onClick: toggle
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('button.favorite')), 1)
  ], 2))
}
}

})